module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-200.c110c6ae.eot";